
export default [

        {
            path:'/streetPat',
            name:'streetPat',
            component:() => import('@/views/streetPat/streetPat'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
    
            },
        },
        {
            path:'/streetPat/list',
            name:'streetPat-list',
            component:() => import('@/views/streetPat/list'),
            meta: {
    
                keepAlive: false, //此组件需要被缓存
    
            }
        },
        {
            path:'/streetPat/detail',
            name:'streetPat-detail',
            component:() => import('@/views/streetPat/detail'),
            meta: {
    
                keepAlive: false, //此组件需要被缓存
    
            }
        },
        
]


// WEBPACK FOOTER //
// ./src/router/streetPat.js